import {ModuleConfiguration} from "../router/model/UserPermission";
import {OpportunitiesServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const OpportunityServiceModule = new ModuleConfiguration(
    OpportunitiesServiceModuleName,
    [AngularJsMaterialModuleName]);